import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { GraduationCapIcon, ChevronDownIcon } from 'lucide-react';
import { findDegreesTemplates } from '../data/findDegreesTemplates';
function slugToLabel(slug: string): string {
  return slug.split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
}
export function Footer() {
  const currentYear = new Date().getFullYear();
  const [isFindDegreesOpen, setIsFindDegreesOpen] = useState(false);
  const scrollToTop = () => window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
  return <footer className="bg-navy-dark text-white pt-16 pb-8" data-id="element-128">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-129">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-130">
          {/* Brand Col */}
          <div className="col-span-1 md:col-span-1" data-id="element-131">
            <Link to="/" onClick={scrollToTop} className="flex items-center mb-4" data-id="element-132">
              <GraduationCapIcon className="h-8 w-8 text-gold mr-2" data-id="element-133" />
              <span className="text-xl font-bold text-white tracking-tight" data-id="element-134">
                OnlineCollege<span className="text-gold" data-id="element-135">Guide</span>
              </span>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed mb-6" data-id="element-136">
              Empowering students to find the perfect online degree program to
              advance their careers and achieve their goals.
            </p>
          </div>

          {/* Links Col 1 */}
          <div data-id="element-137">
            <h3 className="text-sm font-bold uppercase tracking-wider text-gray-300 mb-4" data-id="element-138">
              Top Programs
            </h3>
            <ul className="space-y-3 mb-6" data-id="element-139">
              <li data-id="element-140">
                <Link to="/degrees/business" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-141">
                  Business Administration
                </Link>
              </li>
              <li data-id="element-142">
                <Link to="/degrees/computer-science" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-143">
                  Computer Science
                </Link>
              </li>
              <li data-id="element-144">
                <Link to="/degrees/healthcare" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-145">
                  Nursing & Healthcare
                </Link>
              </li>
              <li data-id="element-146">
                <Link to="/degrees/psychology" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-147">
                  Psychology
                </Link>
              </li>
            </ul>

            {/* Find Degrees Dropdown */}
            <h3 className="text-sm font-bold uppercase tracking-wider text-gray-300 mb-3" data-id="element-148">
              Find Degrees
            </h3>
            <div className="relative" data-id="element-149">
              <button type="button" onClick={() => setIsFindDegreesOpen(open => !open)} aria-expanded={isFindDegreesOpen} aria-haspopup="listbox" className="w-full flex items-center justify-between px-3 py-2 text-sm bg-white/5 hover:bg-white/10 border border-white/10 rounded-md text-gray-200 transition-colors" data-id="element-150">
                <span data-id="element-151">Select a theme</span>
                <ChevronDownIcon className={`w-4 h-4 transition-transform duration-200 ${isFindDegreesOpen ? 'rotate-180' : ''}`} data-id="element-152" />
              </button>

              {isFindDegreesOpen && <ul role="listbox" className="absolute z-20 left-0 right-0 mt-2 bg-navy-dark border border-white/10 rounded-md shadow-xl overflow-hidden" data-id="element-153">
                  {findDegreesTemplates.length === 0 && <li className="px-3 py-2 text-xs text-gray-500 italic" data-id="element-154">
                      No themes available yet
                    </li>}
                  {findDegreesTemplates.map(template => <li key={template.slug} data-id="element-155">
                      <Link to={`/find-degrees/${template.slug}`} onClick={() => {
                  setIsFindDegreesOpen(false);
                  scrollToTop();
                }} className="block px-3 py-2 text-sm text-gray-300 hover:bg-white/10 hover:text-white transition-colors" data-id="element-156">
                        {slugToLabel(template.slug)}
                      </Link>
                    </li>)}
                </ul>}
            </div>
          </div>

          {/* Links Col 2 */}
          <div data-id="element-157">
            <h3 className="text-sm font-bold uppercase tracking-wider text-gray-300 mb-4" data-id="element-158">
              Resources
            </h3>
            <ul className="space-y-3 mb-6" data-id="element-159">
              <li data-id="element-160">
                <Link to="/colleges" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-161">
                  Partner Colleges
                </Link>
              </li>
            </ul>
            <h3 className="text-sm font-bold uppercase tracking-wider text-gray-300 mb-4" data-id="element-162">
              Guides
            </h3>
            <ul className="space-y-3" data-id="element-163">
              <li data-id="element-164">
                <Link to="/request-information" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-165">
                  Request Information
                </Link>
              </li>
              <li data-id="element-166">
                <Link to="/guide/online-christian-colleges" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-167">
                  Online Christian Colleges
                </Link>
              </li>
              <li data-id="element-168">
                <Link to="#" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-169">
                  Financial Aid Guide
                </Link>
              </li>
              <li data-id="element-170">
                <Link to="#" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-171">
                  Accreditation Info
                </Link>
              </li>
              <li data-id="element-172">
                <Link to="#" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-173">
                  Career Paths
                </Link>
              </li>
              <li data-id="element-174">
                <Link to="#" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-175">
                  Student Success Stories
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal Col */}
          <div data-id="element-176">
            <h3 className="text-sm font-bold uppercase tracking-wider text-gray-300 mb-4" data-id="element-177">
              Legal
            </h3>
            <ul className="space-y-3" data-id="element-178">
              <li data-id="element-179">
                <Link to="/privacy-policy" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-180">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-181">
                <Link to="/terms-and-conditions" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-182">
                  Terms of Service
                </Link>
              </li>
              <li data-id="element-183">
                <Link to="/cookie-policy" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-184">
                  Cookie Policy
                </Link>
              </li>
              <li data-id="element-185">
                <Link to="/do-not-sell-my-info" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-186">
                  Do Not Sell My Info
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8" data-id="element-187">
          <div className="text-xs text-gray-400 space-y-4 text-center md:text-left" data-id="element-188">
            <p data-id="element-189">
              <strong data-id="element-190">Advertiser Disclosure:</strong> OnlineCollegeGuide.com is
              an advertising-supported site. Featured or trusted partner
              programs and all school search, finder, or match results are for
              schools that compensate us. This compensation does not influence
              our school rankings, resource guides, or other
              editorially-independent information published on this site.
            </p>
            <p data-id="element-191">
              <strong data-id="element-192">TCPA Disclosure:</strong> By submitting your information
              on this website, you consent to be contacted by our educational
              partners regarding their programs via email, telephone, or text
              message.
            </p>
            <p className="pt-4 text-gray-500" data-id="element-193">
              &copy; {currentYear} OnlineCollegeGuide. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>;
}